const LastIcon: React.FC = () => {
    return (
        <svg width="17" height="21" viewBox="0 0 17 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.4363 0C16.1249 -1.30133e-08 15.8726 0.27151 15.8726 0.606436L15.8726 20.3936C15.8726 20.7285 16.1249 21 16.4363 21C16.7476 21 17 20.7285 17 20.3936L17 0.606436C17 0.271511 16.7476 1.30133e-08 16.4363 0Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.12744 19.1838L1.12744 2.16249L14.073 10.6731L1.12744 19.1838ZM0 19.6163C0 20.374 0.771255 20.8394 1.37227 20.4443L14.9758 11.5011C15.5513 11.1227 15.5513 10.2236 14.9758 9.84521L1.37227 0.902031C0.771255 0.506912 0 0.972236 0 1.72997V19.6163Z"
                fill="white"
            />
        </svg>
    )
}

LastIcon.displayName = 'LastIcon'

export default LastIcon
